export const EMOJI_CATEGORIES = [
  {
    id: "smileys",
    label: "Smileys & People",
    icon: "solar:smile-circle-linear",
    searchTerms: ["smile", "face", "people", "person", "hand", "happy", "sad", "angry", "love"],
    emojis: [
      "😀", "😃", "😄", "😁", "😆", "😅", "🤣", "😂", "🙂", "🙃",
      "😉", "😊", "😇", "🥰", "😍", "🤩", "😘", "😗", "😚", "😙",
      "😋", "😛", "😜", "🤪", "😝", "🤑", "🤗", "🤭", "🤫", "🤔",
      "🤐", "🤨", "😐", "😑", "😶", "😏", "😒", "🙄", "😬", "🤥",
      "😌", "😔", "😪", "🤤", "😴", "😷", "🤒", "🤕", "🤢", "🤮",
      "🤧", "🥵", "🥶", "🥴", "😵", "🤯", "🤠", "🥳", "😎", "🤓",
      "🧐", "😕", "😟", "🙁", "☹️", "😮", "😯", "😲", "😳", "🥺",
      "😦", "😧", "😨", "😰", "😥", "😢", "😭", "😱", "😖", "😣",
      "😞", "😓", "😩", "😫", "🥱", "😤", "😡", "😠", "🤬", "😈",
      "👋", "🤚", "🖐️", "✋", "🖖", "👌", "🤌", "🤏", "✌️", "🤞",
      "🤟", "🤘", "🤙", "👈", "👉", "👆", "👇", "☝️", "👍", "👎",
      "✊", "👊", "🤛", "🤜", "👏", "🙌", "👐", "🤲", "🤝", "🙏",
      "💪", "🦾", "🦿", "🦵", "🦶", "👂", "🦻", "👃", "🧠", "🫀",
      "👶", "🧒", "👦", "👧", "🧑", "👱", "👨", "🧔", "👩", "🧓",
      "👴", "👵", "🙍", "🙎", "🙅", "🙆", "💁", "🙋", "🧏", "🙇",
    ],
  },
  {
    id: "animals",
    label: "Animals & Nature",
    icon: "solar:cat-linear",
    searchTerms: ["animal", "pet", "dog", "cat", "nature", "plant", "flower", "tree", "bird"],
    emojis: [
      "🐶", "🐱", "🐭", "🐹", "🐰", "🦊", "🐻", "🐼", "🐻‍❄️", "🐨",
      "🐯", "🦁", "🐮", "🐷", "🐽", "🐸", "🐵", "🙈", "🙉", "🙊",
      "🐒", "🐔", "🐧", "🐦", "🐤", "🐣", "🐥", "🦆", "🦅", "🦉",
      "🦇", "🐺", "🐗", "🐴", "🦄", "🐝", "🪱", "🐛", "🦋", "🐌",
      "🐞", "🐜", "🪰", "🪲", "🪳", "🦟", "🦗", "🕷️", "🦂", "🐢",
      "🐍", "🦎", "🦖", "🦕", "🐙", "🦑", "🦐", "🦞", "🦀", "🐡",
      "🐠", "🐟", "🐬", "🐳", "🐋", "🦈", "🐊", "🐅", "🐆", "🦓",
      "🦍", "🦧", "🐘", "🦛", "🦏", "🐪", "🐫", "🦒", "🦘", "🦬",
      "🌸", "💮", "🏵️", "🌹", "🥀", "🌺", "🌻", "🌼", "🌷", "🌱",
      "🪴", "🌲", "🌳", "🌴", "🌵", "🌾", "🌿", "☘️", "🍀", "🍁",
    ],
  },
  {
    id: "food",
    label: "Food & Drink",
    icon: "solar:hamburger-menu-linear",
    searchTerms: ["food", "drink", "eat", "fruit", "coffee", "pizza", "burger", "tea", "cake"],
    emojis: [
      "🍎", "🍐", "🍊", "🍋", "🍌", "🍉", "🍇", "🍓", "🫐", "🍈",
      "🍒", "🍑", "🥭", "🍍", "🥥", "🥝", "🍅", "🍆", "🥑", "🥦",
      "🥬", "🥒", "🌶️", "🫑", "🌽", "🥕", "🫒", "🧄", "🧅", "🥔",
      "🍠", "🥐", "🥯", "🍞", "🥖", "🥨", "🧀", "🥚", "🍳", "🧈",
      "🥞", "🧇", "🥓", "🥩", "🍗", "🍖", "🦴", "🌭", "🍔", "🍟",
      "🍕", "🫓", "🥪", "🥙", "🧆", "🌮", "🌯", "🫔", "🥗", "🥘",
      "🫕", "🍝", "🍜", "🍲", "🍛", "🍣", "🍱", "🥟", "🦪", "🍤",
      "🍙", "🍚", "🍘", "🍥", "🥠", "🥮", "🍢", "🍡", "🍧", "🍨",
      "🍦", "🥧", "🧁", "🍰", "🎂", "🍮", "🍭", "🍬", "🍫", "🍿",
      "🍩", "🍪", "🌰", "🥜", "🍯", "🥛", "🍼", "☕", "🫖", "🍵",
    ],
  },
  {
    id: "travel",
    label: "Travel & Places",
    icon: "solar:bus-linear",
    searchTerms: ["travel", "car", "bus", "train", "plane", "home", "house", "hotel", "place"],
    emojis: [
      "🚗", "🚕", "🚙", "🚌", "🚎", "🏎️", "🚓", "🚑", "🚒", "🚐",
      "🛻", "🚚", "🚛", "🚜", "🦯", "🦽", "🦼", "🛴", "🚲", "🛵",
      "🏍️", "🛺", "🚨", "🚔", "🚍", "🚘", "🚖", "🚡", "🚠", "🚟",
      "🚃", "🚋", "🚞", "🚝", "🚄", "🚅", "🚈", "🚂", "🚆", "🚇",
      "🚊", "🚉", "✈️", "🛫", "🛬", "🛩️", "💺", "🛰️", "🚀", "🛸",
      "🚁", "🛶", "⛵", "🚤", "🛥️", "🛳️", "⛴️", "🚢", "⚓", "🪝",
      "⛽", "🚧", "🚦", "🚥", "🗺️", "🗿", "🗽", "🗼", "🏰", "🏯",
      "🏟️", "🎡", "🎢", "🎠", "⛲", "⛱️", "🏖️", "🏝️", "🏜️", "🌋",
      "⛰️", "🏔️", "🗻", "🏕️", "⛺", "🏠", "🏡", "🏘️", "🏚️", "🏗️",
      "🏢", "🏬", "🏣", "🏤", "🏥", "🏦", "🏨", "🏪", "🏫", "🏩",
    ],
  },
  {
    id: "activities",
    label: "Activities",
    icon: "mdi:tennis-ball",
    searchTerms: ["sport", "sports", "game", "ball", "tennis", "football", "music", "trophy", "activity"],
    emojis: [
      "⚽", "🏀", "🏈", "⚾", "🥎", "🎾", "🏐", "🏉", "🥏", "🎱",
      "🪀", "🏓", "🏸", "🏒", "🏑", "🥍", "🏏", "🪃", "🥅", "⛳",
      "🪁", "🏹", "🎣", "🤿", "🥊", "🥋", "🎽", "🛹", "🛼", "🛷",
      "⛸️", "🥌", "🎿", "⛷️", "🏂", "🪂", "🏋️", "🤼", "🤸", "⛹️",
      "🤺", "🤾", "🏌️", "🏇", "🧘", "🏄", "🏊", "🤽", "🚣", "🧗",
      "🚵", "🚴", "🏆", "🥇", "🥈", "🥉", "🏅", "🎖️", "🏵️", "🎗️",
      "🎫", "🎟️", "🎪", "🤹", "🎭", "🩰", "🎨", "🎬", "🎤", "🎧",
      "🎼", "🎹", "🥁", "🪘", "🎷", "🎺", "🪗", "🎸", "🪕", "🎻",
      "🎲", "♟️", "🎯", "🎳", "🎮", "🕹️", "🎰", "🧩", "🃏", "🀄",
    ],
  },
  {
    id: "objects",
    label: "Objects",
    icon: "solar:t-shirt-linear",
    searchTerms: ["phone", "mobile", "computer", "laptop", "camera", "money", "tool", "watch", "key"],
    emojis: [
      "⌚", "📱", "📲", "💻", "⌨️", "🖥️", "🖨️", "🖱️", "🖲️", "🕹️",
      "🗜️", "💽", "💾", "💿", "📀", "📼", "📷", "📸", "📹", "🎥",
      "📽️", "🎞️", "📞", "☎️", "📟", "📠", "📺", "📻", "🎙️", "🎚️",
      "🎛️", "🧭", "⏱️", "⏲️", "⏰", "🕰️", "⌛", "⏳", "📡", "🔋",
      "🔌", "💡", "🔦", "🕯️", "🪔", "🧯", "🛢️", "💸", "💵", "💴",
      "💶", "💷", "🪙", "💰", "💳", "💎", "⚖️", "🪜", "🧰", "🪛",
      "🔧", "🔨", "⚒️", "🛠️", "⛏️", "🪚", "🔩", "⚙️", "🪤", "🧱",
      "⛓️", "🧲", "🔫", "💣", "🧨", "🪓", "🔪", "🗡️", "⚔️", "🛡️",
      "🚬", "⚰️", "🪦", "⚱️", "🏺", "🔮", "📿", "🧿", "💈", "⚗️",
      "🔭", "🔬", "🕳️", "🩹", "🩺", "💊", "💉", "🩸", "🧬", "🦠",
    ],
  },
  {
    id: "symbols",
    label: "Symbols",
    icon: "solar:music-note-linear",
    searchTerms: ["heart", "love", "symbol", "star", "sign", "warning", "check", "mark"],
    emojis: [
      "❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "🤎", "💔",
      "❣️", "💕", "💞", "💓", "💗", "💖", "💘", "💝", "💟", "☮️",
      "✝️", "☪️", "🕉️", "☸️", "✡️", "🔯", "🕎", "☯️", "☦️", "🛐",
      "⛎", "♈", "♉", "♊", "♋", "♌", "♍", "♎", "♏", "♐",
      "♑", "♒", "♓", "🆔", "⚛️", "🉑", "☢️", "☣️", "📴", "📳",
      "🈶", "🈚", "🈸", "🈺", "🈷️", "✴️", "🆚", "💮", "🉐", "㊙️",
      "㊗️", "🈴", "🈵", "🈹", "🈲", "🅰️", "🅱️", "🆎", "🆑", "🅾️",
      "🆘", "❌", "⭕", "🛑", "⛔", "📛", "🚫", "💯", "💢", "♨️",
      "🚷", "🚯", "🚳", "🚱", "🔞", "📵", "🚭", "❗", "❕", "❓",
      "❔", "‼️", "⁉️", "🔅", "🔆", "〽️", "⚠️", "🚸", "🔱", "⚜️",
    ],
  },
  {
    id: "flags",
    label: "Flags",
    icon: "solar:flag-linear",
    searchTerms: ["flag", "country", "india", "usa", "nation"],
    emojis: [
      "🏁", "🚩", "🎌", "🏴", "🏳️", "🏳️‍🌈", "🏳️‍⚧️", "🏴‍☠️", "🇮🇳", "🇺🇸",
      "🇬🇧", "🇨🇦", "🇦🇺", "🇩🇪", "🇫🇷", "🇮🇹", "🇪🇸", "🇯🇵", "🇰🇷", "🇨🇳",
      "🇧🇷", "🇲🇽", "🇷🇺", "🇿🇦", "🇸🇦", "🇦🇪", "🇸🇬", "🇲🇾", "🇹🇭", "🇮🇩",
      "🇵🇭", "🇻🇳", "🇳🇵", "🇧🇩", "🇵🇰", "🇱🇰", "🇳🇿", "🇮🇪", "🇳🇱", "🇧🇪",
      "🇸🇪", "🇳🇴", "🇩🇰", "🇫🇮", "🇵🇱", "🇨🇭", "🇦🇹", "🇵🇹", "🇬🇷", "🇹🇷",
    ],
  },
];

const EMOJI_KEYWORD_GROUPS = {
  smile: ["😀", "😃", "😄", "😁", "😊", "🙂", "😉"],
  happy: ["😀", "😃", "😄", "😁", "😊", "🥰", "😍", "🤩", "😆", "😅"],
  laugh: ["😆", "😅", "🤣", "😂"],
  sad: ["😢", "😭", "😞", "☹️", "🙁", "😔", "😿"],
  cry: ["😢", "😭"],
  angry: ["😡", "😠", "🤬", "👿", "😤"],
  love: ["❤️", "🥰", "😍", "😘", "💕", "💖", "💘", "💝", "💞", "💓"],
  heart: ["❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "🤎", "💔", "💕", "💖", "💘", "💝"],
  thumbs: ["👍", "👎"],
  ok: ["👌", "👍", "🆗"],
  clap: ["👏", "🙌"],
  pray: ["🙏"],
  fire: ["🔥", "💯"],
  star: ["⭐", "🌟", "✨"],
  dog: ["🐶"],
  cat: ["🐱"],
  bird: ["🐦", "🐧", "🐤", "🐔", "🦅", "🦉"],
  lion: ["🦁"],
  tiger: ["🐯"],
  monkey: ["🐵", "🙈", "🙉", "🙊", "🐒"],
  flower: ["🌸", "🌹", "🌺", "🌻", "🌼", "🌷", "💐"],
  tree: ["🌲", "🌳", "🌴", "🌵"],
  sun: ["☀️", "🌞"],
  moon: ["🌙", "🌛", "🌜"],
  rain: ["🌧️", "☔", "⛈️"],
  pizza: ["🍕"],
  burger: ["🍔"],
  coffee: ["☕"],
  tea: ["🍵", "🫖"],
  beer: ["🍺", "🍻"],
  cake: ["🎂", "🍰", "🧁"],
  car: ["🚗", "🚕", "🚙"],
  bus: ["🚌", "🚎"],
  train: ["🚂", "🚆", "🚇", "🚄", "🚅"],
  plane: ["✈️", "🛫", "🛬"],
  home: ["🏠", "🏡"],
  hospital: ["🏥"],
  school: ["🏫"],
  football: ["⚽"],
  cricket: ["🏏"],
  tennis: ["🎾"],
  basketball: ["🏀"],
  music: ["🎵", "🎶", "🎤", "🎧", "🎸", "🎹", "🎷", "🎺", "🥁"],
  phone: ["📱", "📞", "☎️"],
  laptop: ["💻"],
  camera: ["📷", "📸"],
  money: ["💰", "💵", "💴", "💶", "💷", "🪙"],
  india: ["🇮🇳"],
  usa: ["🇺🇸"],
  uk: ["🇬🇧"],
  flag: ["🏁", "🚩", "🏳️", "🏴"],
};

function tokenMatchesTerm(token, term) {
  if (!token || !term) return false;
  return term.includes(token) || token.includes(term);
}

function buildEmojiSearchIndex() {
  const index = new Map();

  const addTerm = (emoji, term) => {
    const normalized = String(term || "").trim().toLowerCase();
    if (!normalized) return;
    if (!index.has(emoji)) index.set(emoji, new Set());
    index.get(emoji).add(normalized);
  };

  EMOJI_CATEGORIES.forEach((cat) => {
    const categoryTerms = [
      cat.id,
      ...cat.label.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean),
      ...(cat.searchTerms || []),
    ];
    cat.emojis.forEach((emoji) => {
      categoryTerms.forEach((term) => addTerm(emoji, term));
    });
  });

  Object.entries(EMOJI_KEYWORD_GROUPS).forEach(([term, emojis]) => {
    emojis.forEach((emoji) => addTerm(emoji, term));
  });

  return index;
}

const EMOJI_SEARCH_INDEX = buildEmojiSearchIndex();

const RECENT_KEY = "wa_emoji_recent";

export function getRecentEmojis() {
  try {
    const raw = localStorage.getItem(RECENT_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.slice(0, 24) : [];
  } catch {
    return [];
  }
}

export function pushRecentEmoji(emoji) {
  if (!emoji) return;
  const recent = getRecentEmojis().filter((e) => e !== emoji);
  recent.unshift(emoji);
  try {
    localStorage.setItem(RECENT_KEY, JSON.stringify(recent.slice(0, 24)));
  } catch {
    // ignore quota errors
  }
}

export function searchEmojis(query) {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return null;

  const tokens = q.split(/\s+/).filter(Boolean);
  const results = [];
  const seen = new Set();

  const addEmoji = (emoji) => {
    if (!emoji || seen.has(emoji)) return;
    seen.add(emoji);
    results.push(emoji);
  };

  Object.entries(EMOJI_KEYWORD_GROUPS).forEach(([term, emojis]) => {
    if (tokens.some((token) => tokenMatchesTerm(token, term))) {
      emojis.forEach(addEmoji);
    }
  });

  EMOJI_SEARCH_INDEX.forEach((terms, emoji) => {
    const matches = tokens.every((token) =>
      [...terms].some((term) => tokenMatchesTerm(token, term)),
    );
    if (matches) addEmoji(emoji);
  });

  return results;
}
